<div class="container">
  <section class="locations" aria-labelledby="locations-heading">
    <h1 id="locations-heading" class="visually-hidden">Locations</h1>

    <div class="locations-layout">
      <!-- Desktop: List on left, map on right -->
      <ng-container *ngIf="!isMobile">
        <div class="list-pane">
          <app-location-list
            [locations]="locations$ | async"
            [selectedId]="selectedId"
            [newestLocationId]="newestLocationId"
            (select)="onSelect($event)">
          </app-location-list>
        </div>

        <div class="map-pane">
          <app-location-map-stub
            [locations]="locations$ | async"
            [selectedId]="selectedId"
            [isMobile]="false"
            [newestLocationId]="newestLocationId"
            (select)="onSelect($event)">
          </app-location-map-stub>
        </div>
      </ng-container>

      <!-- Mobile: Map full screen with draggable sheet -->
      <ng-container *ngIf="isMobile">
        <div class="mobile-map-container">
          <app-location-map-stub
            [locations]="locations$ | async"
            [selectedId]="selectedId"
            [isMobile]="true"
            [newestLocationId]="newestLocationId"
            (select)="onSelect($event)">
          </app-location-map-stub>
          
          <!-- Draggable sheet for locations -->
          <div class="mobile-sheet" [class.sheet-collapsed]="sheetState === 'collapsed'" [class.sheet-half]="sheetState === 'half'" [class.sheet-expanded]="sheetState === 'expanded'">
            <div class="sheet-handle" (touchstart)="onSheetTouchStart($event)" (touchmove)="onSheetTouchMove($event)" (touchend)="onSheetTouchEnd($event)">
              <div class="handle-bar"></div>
            </div>
            <div class="sheet-content">
              <app-location-list
                [locations]="locations$ | async"
                [selectedId]="selectedId"
                [newestLocationId]="newestLocationId"
                (select)="onSelect($event)">
              </app-location-list>
            </div>
          </div>
        </div>
      </ng-container>
    </div>
  </section>
</div>